import { render } from "./ViewOrderProducts.vue?vue&type=template&id=257ec130"
import script from "./ViewOrderProducts.vue?vue&type=script&lang=js"
export * from "./ViewOrderProducts.vue?vue&type=script&lang=js"

import "./ViewOrderProducts.vue?vue&type=style&index=0&id=257ec130&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__